import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardPermissions } from '../../../core/services/dashboard.service';
import { QuickActionType } from '../../../core/models/quick-action.model';
import { I18nService } from '../../../core/services/i18n.service';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

export interface DashboardQuickActionRequest {
  actionType: QuickActionType;
  contactCallbackExpanded: boolean;
}

type DashboardQuickActionId = 'document_upload' | 'callback';

interface QuickActionItem {
  id: DashboardQuickActionId;
  label: string;
  hidden: boolean;
}

@Component({
  selector: 'app-quick-actions',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './quick-actions.component.html',
  styleUrl: './quick-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickActionsComponent {
  private readonly i18n = inject(I18nService);

  @Input({ required: true }) permissions!: DashboardPermissions;
  @Output() readonly quickAction = new EventEmitter<DashboardQuickActionRequest>();

  actionItems(): QuickActionItem[] {
    return [
      {
        id: 'document_upload',
        label: this.i18n.t('quickActions.documentUpload'),
        hidden: false,
      },
      {
        id: 'callback',
        label: this.i18n.t('quickActions.callback'),
        hidden: false,
      },
    ];
  }

  triggerAction(actionId: DashboardQuickActionId): void {
    this.quickAction.emit({
      actionType: actionId === 'callback' ? 'contact' : actionId,
      contactCallbackExpanded: actionId === 'callback',
    });
  }
}
